import template from "./image-selector.html";

const ImageSelectorComponent = {
  bindings: {
    image: "<",
    onSelect: "&",
  },
  template: template,
  controller: class ImageSelectorController {
    /* @ngInject */
    constructor(ModalsManager) {
      this.ModalsManager = ModalsManager;
    }

    async launchImageSelector() {
      const metadata = await this.ModalsManager.openImageSelectorModal();
      if (!metadata) return;

      this.onSelect({ image: metadata });
    }

    removeImage() {
      this.onSelect({ image: null });
    }
  },
};

export default ImageSelectorComponent;
